"use client";
import { create } from "zustand";

export type OnboardingStep = "name" | "avatar" | "quiz" | "team" | "department" | "done";

interface AuthState {
  user: {
    id: string;
    name: string;
    email: string;
    avatar: string;
    team: string | null;
    territoryName: string | null;
    xp: number;
    level: number;
  } | null;
  setUser: (user: AuthState["user"]) => void;
  isAuthenticated: boolean;

  onboardingStep: OnboardingStep;
  setOnboardingStep: (step: OnboardingStep) => void;
}

function createAuthStore() {
  return create<AuthState>((set) => ({
    user: null,
    setUser: (user) => set({ user, isAuthenticated: !!user }),
    isAuthenticated: false,

    onboardingStep: "name",
    setOnboardingStep: (step) => set({ onboardingStep: step }),
  }));
}

const _g = globalThis as Record<string, unknown>;
if (!_g.__surggiesAuthStore) _g.__surggiesAuthStore = createAuthStore();
export const useAuthStore = _g.__surggiesAuthStore as ReturnType<typeof createAuthStore>;
